<div *routerOuter class="row">
  <div class="col col-120 col-lg-100 col-xl-80" *ngIf="item">

    <form-group-context label="ID">
      <span>{{ item.id }}</span>
    </form-group-context>

    <form-group-context label="Created At">
      <span>{{ item.createdAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Updated At">
      <span>{{ item.updatedAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Name">
      <span>{{ item.name }}</span>
    </form-group-context>

    <form-group-context label="Store">
      <entity-link type="store" [item]="item.store" [relativePath]="true"></entity-link>
    </form-group-context>

    <form-group-context label="Active">
      <badge-exist existText="Active" existColor="success" [item]="item.active"></badge-exist>
    </form-group-context>


    <form-group-context label="Legacy">
      <badge-exist existText="Legacy" existColor="success" [item]="item.legacy"></badge-exist>
    </form-group-context>


    <form-group-context label="Available for downloading">
      <badge-exist existText="Available" existColor="success" [item]="item.availableForDownloading"></badge-exist>
    </form-group-context>

    <form-group-context label="Product">
      <entity-link type="product" [item]="item.product" [relativePath]="true"></entity-link>
    </form-group-context>

    <form-group-context label="Assets" *ngIf="item.legacy">
      <a class="d-flex" *ngFor="let asset of item.assets" [attr.href]="asset.Location">{{ asset.name }}
        <ng-container *ngIf="asset.locale">{{ asset.locale | flag }}</ng-container>
      </a>
    </form-group-context>

    <form-group-context label="Covers" *ngIf="item.legacy">
      <a class="d-flex" *ngFor="let asset of item.covers" [attr.href]="asset.Location">{{ asset.name }}
        <ng-container *ngIf="asset.locale">{{ asset.locale | flag }}</ng-container>
      </a>
    </form-group-context>
  </div>
</div>
